/**
 * TRENDYOL STYLE COLLECTION ELEMENTS JAVASCRIPT
 * Dosya: assets/trendyol-collection.js
 * 
 * Özellikler:
 * - Flash ürün geri sayımı (4 saat)
 * - İstatistik geçişi (2 saniye)
 * - Ürün sayfası ile senkronizasyon (localStorage)
 */

(function() {
  'use strict';
  
  // ========================================
  // 1. FLASH ÜRÜN GERİ SAYIM
  // ========================================
  function initFlashCountdown() {
    const timers = document.querySelectorAll('.ty-flash-timer');
    
    timers.forEach(timer => {
      const productId = timer.getAttribute('data-product-id');
      
      // Her ürün için farklı başlangıç zamanı (tutarlılık için)
      const hash = parseInt(productId) % 240; // 0-239 dakika arası
      let totalSeconds = (4 * 3600) - (hash * 60); // 4 saat - hash dakika
      
      function updateTimer() {
        totalSeconds--;
        
        if (totalSeconds < 0) {
          totalSeconds = 4 * 3600 - 1; // 4 saate sıfırla
        }
        
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        const display = 
          String(hours).padStart(2, '0') + ':' +
          String(minutes).padStart(2, '0') + ':' +
          String(seconds).padStart(2, '0');
        
        timer.textContent = display;
      }
      
      // İlk görüntü
      updateTimer();
      
      // Her saniye güncelle
      setInterval(updateTimer, 1000);
    });
  }
  
  // ========================================
  // 2. İSTATİSTİK GEÇİŞİ - HER ÜRÜN FARKLI RASGELE SIRA
  // ========================================
  function initStatsRotation() {
    const wrappers = document.querySelectorAll('.ty-stats-wrapper');
    
    wrappers.forEach(wrapper => {
      const stats = Array.from(wrapper.querySelectorAll('.ty-stat'));
      const productId = wrapper.getAttribute('data-product-id');
      
      if (stats.length === 0) return;
      
      // Her ürün için farklı rastgele sıra oluştur (product.id bazlı - tutarlı)
      const seed = parseInt(productId);
      const shuffledIndices = [0, 1, 2];
      
      // Fisher-Yates shuffle with seed
      for (let i = shuffledIndices.length - 1; i > 0; i--) {
        const j = Math.floor(((seed * (i + 1)) % 97) / 97 * (i + 1));
        [shuffledIndices[i], shuffledIndices[j]] = [shuffledIndices[j], shuffledIndices[i]];
      }
      
      // Stats'ları yeni sıraya göre yeniden düzenle
      const shuffledStats = shuffledIndices.map(i => stats[i]);
      
      let currentIndex = 0;
      
      // İlk stat'ı göster
      shuffledStats[0].classList.add('ty-stat-active');
      
      // İstatistikleri döndür
      function rotateStats() {
        shuffledStats[currentIndex].classList.remove('ty-stat-active');
        currentIndex = (currentIndex + 1) % shuffledStats.length;
        shuffledStats[currentIndex].classList.add('ty-stat-active');
      }
      
      // 2 saniyede bir geçiş
      setInterval(rotateStats, 2000);
      
      // ========================================
      // 3. ÜRÜN SAYFASI SENKRONİZASYONU
      // ========================================
      // İstatistikleri localStorage'a kaydet
      // Ürün sayfasında aynı sayıları kullanmak için
      try {
        const statsData = {
          productId: productId,
          views: wrapper.getAttribute('data-views'),
          cart: wrapper.getAttribute('data-cart'),
          watching: wrapper.getAttribute('data-watching'),
          timestamp: Date.now()
        };
        
        localStorage.setItem('ty_stats_' + productId, JSON.stringify(statsData));
      } catch (e) {
        // localStorage hatası - sessizce devam et
        console.log('Trendyol stats: localStorage not available');
      }
    });
  }
  
  // ========================================
  // 4. SAYFA YÜKLENİNCE BAŞLAT
  // ========================================
  function init() {
    initFlashCountdown();
    initStatsRotation();
    
    console.log('✅ Trendyol collection elements initialized');
  }
  
  // Sayfa hazır olduğunda başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // ========================================
  // 5. AJAX PAGINATION DESTEĞİ
  // ========================================
  // Koleksiyon sayfası sayfalandırma sonrası yeniden başlat
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });
  
})();

/**
 * ÜRÜN SAYFASI İÇİN HELPER FONKSİYON
 * 
 * Ürün sayfasında şunu kullanın:
 * 
 * const productId = {{ product.id }};
 * const savedStats = localStorage.getItem('ty_stats_' + productId);
 * 
 * if (savedStats) {
 *   const stats = JSON.parse(savedStats);
 *   // stats.views, stats.cart, stats.watching kullan
 * }
 */
